import { FC } from 'react'
import { BottomArea } from '../BottomArea/BottomArea'
import { Message } from '../components'
import { Content, Page } from '../components/Page'
import { PageTitle } from '../components/PageTitle'
import FilterSelects from '../Filter/FilterSelects'
import { changeFilter, openFilter } from '../state/filter/filterSlice'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import { isLoading } from '../state/timetable/timetableSlice'
import { getFilteredTimetable } from '../TimetableList/selectors'
import TimetableFlat from './TimetableFlat'

// const { setLoading, setArtists } = timetableActions

type Props = {
  showFilterButton?: boolean
}

const TimetableFlatContainer: FC<Props> = ({ showFilterButton = true }) => {
  const dispatch = useAppDispatch()
  // const navigate = useNavigate()

  // const timetable = useAppSelector(getTimetable)
  // const favorites = useAppSelector(getFavorites)
  const loading = useAppSelector(isLoading)
  // const day = useAppSelector(getDay)

  const entriesWithFavorites = useAppSelector(getFilteredTimetable)

  // Add isFavorite property to entries
  // const entriesWithFavorites = timetable
  //   // .filter((entry) => entry.day === day)
  //   .map((entry) => ({
  //     ...entry,
  //     isFavorite: favorites.includes(entry.showId),
  //   }))

  // useEffect(() => {
  //   const loadTimetable = async () => {
  //     dispatch(setLoading(true))

  //     import('../artists.json')
  //       .then((m) => m.default)
  //       .then((loadedArtists) => {
  //         console.log('Artists loaded')
  //         const artists = loadedArtists
  //         dispatch(setArtists(artists))
  //       })
  //   }

  //   loadTimetable()
  // }, [dispatch])

  const handleEventClick = (showId: string) => {
    // dispatch(toggleFav(showId))

    dispatch(
      changeFilter({
        filterId: 'info',
        value: showId,
      }),
    )
    dispatch(openFilter('info'))
  }

  if (loading) {
    return (
      <Page withSolidBackground>
        <Content>
          <PageTitle title={<Message id="LOADING" />} />
        </Content>
      </Page>
    )
  }

  return (
    <>
      <Page>
        <TimetableFlat
          entries={entriesWithFavorites}
          onEventClick={handleEventClick}
        />
        {/* <BottomArea showFilterButton={false} gradientType="none" /> */}
      </Page>
      <FilterSelects />
      <BottomArea showFilterButton={showFilterButton} gradientType="none" />
    </>
  )
}

export default TimetableFlatContainer
